<template>
    <div class="content" type="false">
        <headers></headers>
        <!-- <img src="https://oss.eventnet.cn/H5/zhongan/images/player.png?v=0.1" alt="xxsd" class="xxsd" /> -->
        <video muted class="video" loop="loop" x5-playsinline="true" playsinline="true" preload="auto" autoplay="autoplay" :src="$t('index').src" :poster="$t('index').poster"></video>
        <div class="footer">Copyright 2021 mi.com . All Rights Reserved. 京ICP备18018739号-1</div>
    </div>
</template>

<script>
    import headers from "../../components/headers.vue"
    export default {
        components: {
            headers
        },
        name: 'pcindex',
        data() {
            return {
                lang: ""
            }
        },
        created() {
            let lang = localStorage.getItem("lang");
            this.$i18n.locale = this.lang = lang;
        },
        mounted() {

        },
        methods: {}
    }
</script>
<style scoped>
    .content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    
    .video {
        /* width: 100%; */
        flex: 1;
        height: 100%;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
</style>


// WEBPACK FOOTER //
// src/views/pc/index.vue